import {AfterViewInit, Directive, ElementRef} from '@angular/core';

@Directive({
  selector: '[appAutofocus]'
})
export class AutofocusDirective implements AfterViewInit {
  constructor(private element: ElementRef<HTMLInputElement>) {

  }

  ngAfterViewInit(): void {
    if (this.element.nativeElement.autofocus) {
      this.element.nativeElement.focus();
    }
  }
}
